import { FREE_STANDING_APPOINTMENT_CREATE, FREE_STANDING_APPOINTMENT_ERROR_CLEAR } from '../constants/freeStandingAppointmentTypes';

export function freeStandingAppointmentCreate(params) {
  return {
    type: FREE_STANDING_APPOINTMENT_CREATE,
    payload: params
  };
}

export function freeStandingAppointmentErrorClear() {
  return {
    type: FREE_STANDING_APPOINTMENT_ERROR_CLEAR
  };
}



// WEBPACK FOOTER //
// ./app/actions/freeStandingAppointmentAction.js